import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import FloatingActionButton from 'components/Shared/FloatingActionButton'; 
import AddDocumentForm from 'components/Documents/AddDocument';
import DocumentsGrid from 'components/Documents/DocumentsGrid';
import {FormProvider } from 'context/FormContext';
import AuthCheck from 'components/Shared/AuthCheck';

const tabs = [
  new Tab({label: "Documents", value: "DocumentsGrid", scope: "Documents", action: "read"}),
  new Tab({label: "Add Document", value: "addDocuments", scope: "Documents", action: "create"})
]

const Documents = () => {
  const [activeTab, setActiveTab] = useState("DocumentsGrid");
  
  return (
    <FormProvider>
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
    {(() => {
        switch (activeTab) {
          case "DocumentsGrid":   return <DocumentsGrid />;
          case "addDocuments":  return <AddDocumentForm callback={() => {setActiveTab("DocumentsGrid")}}/>;
          default:      return <DocumentsGrid />;
        }
      })()}   

    <AuthCheck scope="Documents" action="create"><FloatingActionButton onClick={() => setActiveTab("addDocuments")}><AddIcon /></FloatingActionButton></AuthCheck>

    </TabbedPage>
    </FormProvider>
  )
}

export default Documents;